import { render, staticRenderFns } from "./DecisionOpinion.vue?vue&type=template&id=2a8f23b0&scoped=true&"
import script from "./DecisionOpinion.vue?vue&type=script&lang=js&"
export * from "./DecisionOpinion.vue?vue&type=script&lang=js&"
import style0 from "./DecisionOpinion.vue?vue&type=style&index=0&id=2a8f23b0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a8f23b0",
  null
  
)

export default component.exports